import React from 'react';

import CircularProgress, {
  CircularProgressProps,
} from '@material-ui/core/CircularProgress';

export const LoadingIndicator = (props: CircularProgressProps) => (
  <CircularProgress {...props} />
);
